import React from 'react';
import { DepartmentUnitType } from '@models/departments-and-units/units.model.ts';

export enum ScreenName {
  IN_ROOM_DINING = 'In-Room Dining',
  SPA_WELLNESS = 'SPA & Wellness',
  SHOP = 'Shop',
  ROOM_SERVICES = 'Room Services',
  TRANSFERS = 'Transfers'
}

const SCREEN_COLORS: Record<ScreenName, string> = {
  [ScreenName.SPA_WELLNESS]: 'var(--purple-5)',
  [ScreenName.ROOM_SERVICES]: 'var(--pink)',
  [ScreenName.SHOP]: 'var(--blue-3)',
  [ScreenName.TRANSFERS]: 'var(--green)',
  [ScreenName.IN_ROOM_DINING]: 'var(--purple)'
};

export const getScreenNameByType = (type?: string): ScreenName | null => {
  if (!type) return null;

  const typeToScreen: Record<string, ScreenName> = {
    [DepartmentUnitType.RESTURANTS]: ScreenName.IN_ROOM_DINING,
    [DepartmentUnitType.BARS]: ScreenName.IN_ROOM_DINING,
    [DepartmentUnitType.SPA]: ScreenName.SPA_WELLNESS,
    [DepartmentUnitType.TENNIS_COURT]: ScreenName.SPA_WELLNESS,
    [DepartmentUnitType.BEAUTY_SALON]: ScreenName.SPA_WELLNESS,
    [DepartmentUnitType.SHOPS]: ScreenName.SHOP,
    [DepartmentUnitType.ROOM_SERVICE]: ScreenName.ROOM_SERVICES,
    [DepartmentUnitType.TRANSPORT]: ScreenName.TRANSFERS
  };

  return typeToScreen[type] || null;
};

export const getScreenColor = (screenName: ScreenName): string => {
  return SCREEN_COLORS[screenName] || 'var(--gray)';
};

export const ScreenBadge: React.FC<{ type?: string }> = ({ type }) => {
  const screenName = getScreenNameByType(type);
  if (!screenName) return null;

  const color = getScreenColor(screenName);

  return (
    <div
      className={`inline-flex items-center font-semibold text-[10px] 
      whitespace-nowrap max-h-6.25 px-2.5 py-1 rounded max-lg-xl:max-h-5`}
      style={{
        backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
        color: color
      }}
    >
      {screenName}
    </div>
  );
};
